module.exports = __webpack_public_path__ + "static/black-alsatian-wall-8e9457f7698b65bc7641e082374497c1.svg";